import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '../services/authService';
import { useTranslation } from '../contexts/LocaleContext';

const Login: React.FC = () => {
  const t = useTranslation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [sessionExpired, setSessionExpired] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (searchParams.get('session_expired') === '1') {
      setSessionExpired(true);
      setSearchParams({}, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      await authService.login(login, password);
      navigate('/');
    } catch (err: any) {
      const msg = err.response?.data?.message ?? err.response?.data?.error ?? err.message ?? t('errors.loginFailed');
      setError(typeof msg === 'string' ? msg : t('errors.loginFailed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="d-flex w-100 vh-100 justify-content-center align-items-center">
      <form onSubmit={handleSubmit}>
        <div className="d-flex flex-column align-items-center p-4 border rounded bg-light">
          <h5>{t('Login')}</h5>
          {sessionExpired && (
            <div className="alert alert-info w-100" role="alert">
              Сессия истекла. Войдите снова.
            </div>
          )}
          {error && (
            <div className="alert alert-danger w-100" role="alert">
              {error}
            </div>
          )}
          <div className="form-group my-2">
            <input
              type="text"
              id="login"
              className="form-control"
              name="email"
              placeholder={t('formField.namePlaceholder')}
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              required
            />
          </div>
          <div className="form-group my-2">
            <input
              type="password"
              id="password"
              className="form-control"
              name="password"
              placeholder={t('formField.passwordPlaceholder')}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary my-2 w-100" disabled={loading}>
            {loading ? t('Logging in...') : t('Login')}
          </button>
        </div>
      </form>
    </main>
  );
};

export default Login;
